import React, { useState } from 'react';
import { createStyles, Title, Text, Button, Container, useMantineTheme, Grid, Card, Image, Group } from '@mantine/core';
import { Database } from 'tabler-icons-react';

const useStyles = createStyles((theme) => ({
  wrapper: {
    position: 'relative',
    paddingTop: 120,
    paddingBottom: 80,
    backgroundColor: 'white',

    '@media (max-width: 755px)': {
      paddingTop: 80,
      paddingBottom: 60,
    },
  },

  inner: {
    position: 'relative',
    zIndex: 1,
  },

  accentTitle: {
    color: '#1c7ed6',
    fontSize: 80,
    fontWeight: 800,
    textAlign: 'center',
  },

  title: {
    textAlign: 'center',
    fontWeight: 800,
    fontSize: 40,
    letterSpacing: -1,
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    marginBottom: theme.spacing.xs,
    fontFamily: `Poppins, ${theme.fontFamily}`,

    '@media (max-width: 520px)': {
      fontSize: 28,
      textAlign: 'left',
    },
  },

  description: {
    textAlign: 'center',

    '@media (max-width: 520px)': {
      textAlign: 'left',
      fontSize: theme.fontSizes.md,
    },
  },

  controls: {
    marginTop: theme.spacing.lg,
    display: 'flex',
    justifyContent: 'center',

    '@media (max-width: 520px)': {
      flexDirection: 'column',
    },
  },

  control: {
    '&:not(:first-of-type)': {
      marginLeft: theme.spacing.md,
    },

    '@media (max-width: 520px)': {
      height: 42,
      fontSize: theme.fontSizes.md,

      '&:not(:first-of-type)': {
        marginTop: theme.spacing.md,
        marginLeft: 0,
      },
    },
  },
}));

const applicationLink = 'https://docs.google.com/forms/d/e/1FAIpQLSeGAeNZ8-5VvmLMYoLTJGwOkY3Z7Hod60lY6pOIRjhJWApThg/viewform?usp=sf_link'

export function HowItWorks() {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  return (
    <Container pt='xl' my='xl'>
      <Title align='center' order={2}>How it Works</Title>
      <Grid>
        <Grid.Col sm={4} xs={12}>
          <Card shadow='md' radius='lg'>
            <Title order={5} className={classes.accentTitle}>1</Title>
            <Title my='md' order={5}>Apply and Enroll</Title>
            <Text size='sm'>Fill out <a href={applicationLink} target="_blank">the application</a> to have your collection added to NFT Backers. Once approved, you can enroll your collection, adding NFT Backers to your collection notifications.</Text>
          </Card>
        </Grid.Col>
        <Grid.Col sm={4} xs={12}>
          <Card shadow='md' radius='lg'>
            <Title order={5} className={classes.accentTitle}>2</Title>
            <Title  my='md' order={5}>Add/Upgrade Schema</Title>
            <Text size='sm'>Create a new schema to use for NFT Backers, or upgrade an existing one. We require a special attribute that tells us what to back NFTs with. You will use this schema to create templates.</Text>
          </Card>
        </Grid.Col>
        <Grid.Col sm={4} xs={12}>
          <Card shadow='md' radius='lg'>
          <Title order={5} className={classes.accentTitle}>2</Title>
            <Title my='md' order={5}>Create a Template</Title>
            <Text size='sm'>Use your NFT Backers schema to create a new template. You can choose exactly what backing to add whenever an new NFT is minted from this NFT Backers template.</Text>
          </Card>
        </Grid.Col>
      </Grid>
    </Container>
  )
}

export function Hero() {
  const { classes } = useStyles();
  const theme = useMantineTheme();

  const [showHowItWorks,setShowHowItWorks] = useState(false)

  return (
    <Container className={classes.wrapper} size={1400}>
      <div className={classes.inner}>
        <Title className={classes.title}>
          Where creators{' '}
          <Text component="span" color={theme.primaryColor} inherit>
            add value
          </Text>{' '}
          to their collections
        </Title>

        <Container p={0} size={600}>
          <Text size="lg" color="dimmed" className={classes.description}>
            You're just a few clicks away from creating NFT 2.0 assets and adding real-world value backing to your collection!
          </Text>
        </Container>

        <div className={classes.controls}>
          <Button variant="default" size="lg" className={classes.control} mr='xl' component='a' target="_blank" href={applicationLink}>
            Request Access
          </Button>
          {/* <Button className={classes.control} size="lg" variant="default" color="gray">
            Create
          </Button> */}
          <Button onClick={()=>{setShowHowItWorks(!showHowItWorks)}}className={classes.control} size="lg">
            How it Works
          </Button>
        </div>
      </div>
      { showHowItWorks ? <HowItWorks /> : '' }
    </Container>
  );
}